<template>
  <div class="template-field">
    <v-autocomplete
      v-if="isAutocomplete"
      :label="name"
      v-model="model"
      outlined
      :disabled="disabled"
      class="custom__autocomplete"
      :dense="dense"
      :rules="validationRules"
      :prepend-inner-icon="prependIcon"
      :clearable="isClearable"
      :items="items"
      item-text="name"
      :hide-details="hide"
      item-value="value"
      @change="input()"
    >
      <template v-slot:item="data">
        <template v-if="isObject(data)">
          <v-list-item-content v-html="data.item.name"></v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-content>
            <div v-html="data.item.name"></div>
            <span class="red--text" v-if="data.item.is_donot"
              >(Do not service)</span
            >
          </v-list-item-content>
        </template>
      </template>
      <template v-slot:append-outer>
        <create :isJob="true" v-if="type == 'zipcode' && isNotField"></create>
      </template>
    </v-autocomplete>
    
    <v-select
      v-if="type == 'select'"
      :prepend-inner-icon="prependIcon"
      :label="name"
      :hide-details="hide"
      v-model="model"
      :dense="dense"
      :disabled="selectTypeDisabled"
      outlined
      :clearable="isClearable"
      :rules="validationRules"
      :items="items"
      item-text="name"
      item-value="value"
      @change="input()"
      :class="{
        'custom-error-look':
          /key category/i.test(itemName) ||
          /difficulty fee/i.test(itemName) ||
          /applicable item/i.test(itemName) ||
          /make above/i.test(itemName),
      }"
    >
    </v-select>
    
    <v-textarea
      v-if="type == 'textarea'"
      :prepend-inner-icon="prependIcon"
      :label="name"
      v-model="model"
      :clearable="isClearable"
      outlined
      :dense="dense"
      :hide-details="hide"
      :rules="validationRules"
      @change="input"
      @blur="$emit('blur')"
    >
    </v-textarea>
   
    <v-text-field
      :prepend-inner-icon="prependIcon"
      v-if="isText"
      :label="name"
      v-model="model"
      :clearable="isClearable"
      :hide-details="hide"
      :value="value"
      outlined
      :disabled="disabled"
      :dense="dense"
      :type="item.field_type"
      :rules="validationRules"
      @blur="$emit('blur')"
      @input="input"
      :class="{
        'disabled-input': disabled,
        'custom-error-look':
          /key category/i.test(itemName) ||
          /difficulty fee/i.test(itemName) ||
          /applicable item/i.test(itemName) ||
          /make above/i.test(itemName),
        'green-border': isGreen
      }"
    > 
    </v-text-field>
    
    <div class="d-flex phone-input-wrapper" v-if="type == 'phone'">
    <!-- Country Code Dropdown -->
    <v-select
      v-model="phoneCountryCode"
      :items="['+1', '+52']"
      outlined
      dense
      hide-details
      class="mr-2 country-code-select"
      style="max-width: 100px;"
      @change="updatePhoneNumber"
      :disabled="disabled"
    >
    </v-select>

    <!-- 10-digit Phone Number Input -->
    <v-text-field-simplemask
      class="flex-1"
      :label="name"
      :clearable="isClearable"
      v-model="phoneLocalNumber"
      :hide-details="hide"
      @input="updatePhoneNumber"
      @blur="$emit('blur')"
      :disabled="disabled"
      v-bind:properties="{
        prefix: '',
        'prepend-inner-icon': prependIcon,
        rules: isRequired ? phoneRules : [],
        suffix: '',
        readonly: false,
        disabled: disabled,
        outlined: true,
        dense: dense,
        clearable: false,
        placeholder: '(123) 456-7890',
      }"
      v-bind:options="{
        inputMask: '(###) ###-####',
        outputMask: '##########',
        empty: null,
        applyAfter: false,
        alphanumeric: false,
        lowerCase: false,
      }"
    >
    </v-text-field-simplemask>

      
      <search
          v-if="isCreate"
          :disabled="isValidPhone"
          @onCustomerSelect="$parent.initCustomerSelect($event)"
          :phone="fullPhoneNumber"
        ></search>
    </div>
    
    <vuetify-google-autocomplete
      :id="item.id"
      :label="name"
      v-if="type == 'address'"
      v-model="model"
      :clearable="isClearable"
      class="address_input"
      :dense="dense"
      outlined
      v-on:placechanged="getAddressData"
      :hide-details="hide"
      :rules="validationRules"
      @input="input"
      :prepend-inner-icon="prependIcon"
    >
      <template v-slot:append-outer>
        <div class="d-flex" v-if="isCreate && isAddressField">
          <SelectCMP @onCMPSelect="$parent.onCMPSelect($event)"></SelectCMP>
          <v-btn
            depressed
            class="success"
            tile
            v-if="isAddCMP"
            :width="is_mobile ? '' : '120px'"
            color="white"
            @click="addCMP()"
            :height="$root.dense ? '40px' : '56px'"
          >
            {{ is_mobile ? "ADD" : "ADD AS CMP" }}
          </v-btn>
        </div>
      </template>
    </vuetify-google-autocomplete>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { getDateTime } from "../../../assets/js/common";
import customerModal from "../../../assets/js/customer.modal";
import { cmp, functions } from "../../../assets/js/firebase";
import { EMAIL, EMAIL_OPTIONAL, FIELD, PHONE } from "../../../assets/js/rules";
import Create from "../../zipcodes/Create.vue";
import Search from "./Search.vue";
import SelectCMP from "./SelectCMP.vue";
import { EventBus } from "../../../main";
export default {
  components: { Create, Search, SelectCMP },
  props: {
    item: Object,
    form: {
      type: Object,
      default: () => ({}),
    },
    value: [String, Number],
    label: {},
    toolbar: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isDense: {
      type: Boolean,
      default: false,
    },
    hide: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    isClearable: { type: Boolean, default: false },
    itemName: String,
    validationRules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      model: "",
      phoneRules: PHONE,
      phoneCountryCode: '+1',  // Default to US
      phoneLocalNumber: '',
    };
  },
  created() {
    this.checkNumber();
  },
  watch: {
    value(val) {
      if (this.type === 'phone') {
        this.parsePhoneValue(val);
      } else {
        this.model = val;
        this.input();
      }
    },
  },
  computed: {
    prependIcon() {
      if (this.$route.name == "fields") return "";
      let isCMMField =
        [
          customerModal.KEY_CATEGORY,
          customerModal.APPLICABLE_ITEM_NUMBERS,
        ].indexOf(this.item.id) != -1;
      if (isCMMField) {
        return this.items.length ? "mdi-check-bold" : "mdi-close";
      }
      let list = [];
      this.fieldConditions.forEach((i) => {
        i.perform.forEach((i) => {
          if (i.field == this.item.id) {
            list.push(i);
          }
        });
      });
      return list.length != 0 ? "mdi-at" : "";
    },
    isAddCMP() {
      let form = this.$parent.form;
      let landmark = form[customerModal.LANDMARK];
      let address = form[customerModal.ADDRESSS];
      let map = form[customerModal.MAP_LINK];
      let zip = form[customerModal.ZIPCODE];
      if (!landmark) return false;
      let item = this.$store.getters.cmp.find((item) => {
        return item.landmark == landmark;
      });
      if (item != null) return false;
      return address && map && zip;
    },
    isCreate() {
      return this.$route.name == "customer-create";
    },
    // isValidPhone() {
    //   return this.model && false;//this.model.toString().length != 10;
    //   },
    isNotField() {
      return this.$route.name != "fields";
    },
    name() {
      let label = this.label ? this.label : this.item.name;
      return label;
    },
    dense() {
      return this.isDense ? true : this.$root.dense;
    },
    disabled() {
      // let fields = [
      //   customerModal.APPLICABLE_ITEM_NUMBERS,
      //   customerModal.KEY_CATEGORY,
      // ];
      // let isCarMake = this.$route.name == "car-make-update";
      // if (fields.indexOf(this.item.id) != -1 && !this.isAdmin && !isCarMake) {
      //   return true;
      // }
      if (
        this.item.key == customerModal.CAR_UNLOCKING ||
        this.item.key == customerModal.LOST_CAR_KEY 
      ) {
        return true;
      }
      return (this.item.is_calculated == true || this.item.is_disabled == true) && this.$route.name !== 'fields';
    },
    selectTypeDisabled() { // check for the disabled flag in "select" type fields
      return this.item?.is_disabled && (this.$route.name !== 'fields');
    },
    type() {
      return this.item.field_type;
    },
    rules() {
      let { type, isRequired, toolbar } = this;
      let { is_required, id } = this.item;
      let isReasonField = id == customerModal.REASON_FOR_CANCELLATION;
      let isCancelled = toolbar.disposition == customerModal.DISPOSITION_CANCEL;
      if (isReasonField && isCancelled) return FIELD;
      if (!isRequired) return [];
      if (type == "email" && is_required == false) {
        return EMAIL_OPTIONAL;
      }
      if (type == "email" && is_required == true) return EMAIL;
      if (is_required == false) return [];
      return FIELD;
    },
    options() {
      let list = [];
      if (this.item.options instanceof Array == false) return list;
      this.item.options.forEach((item) => {
        let { name } = item;
        list.push({
          value: name,
          name: name,
        });
      });
      return list;
    },
    items() {
      let { type, getSelects } = this;
      let keyCategories = [
        customerModal.KEY_CATEGORY,
        customerModal.APPLICABLE_ITEM_NUMBERS,
      ];
      //WIP
      if (type === "make") return getSelects(this.makes);
      if (type === "make-unlocking") return getSelects(this.makesUnlocking);
      if (type === "model") return getSelects(this.models);
      if (type === "year") return getSelects(this.years);
      if (type === "zipcode") return getSelects(this.zipcodes);
      if (keyCategories.indexOf(this.item.id) != -1) {
        const valuesArray = this.keyCategorieOrAppItemNumbers;
        return valuesArray;
      }
      if (type === "select" || type === "autocomplete") {
        return getSelects(this.options);
      }
      return [];
    },
    zipcodes() {
      return this.$store.getters.zipcodes.map((item) => {
        let { zipcode, community, zone, is_donot } = item;
        let doc = {};
        doc.id = item.id;
        doc.name = `${zipcode} / ${community} / ${zone}`;
        if (is_donot == true) {
          doc.name += " / Do not Service";
        }
        return doc;
      });
    },
    makes() {
      let list = [];
      const isLostCar = this.form[customerModal.LOST_CAR_KEY] !== undefined;
      const isCarUnlocking = this.form[customerModal.CAR_UNLOCKING] !== undefined;

      const makesList = isLostCar
        ? this.$store.getters.makes
        : isCarUnlocking
        ? this.$store.getters.makesUnlocking
        : this.$store.getters.makes;

      list = makesList.map(({ id, name, make_id }) => {
        return {
          id,
          name: make_id ? `(${make_id}) ${name}` : name,
        };
      });

      return list.sort(function(a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    makesUnlocking() {
      let list = [];

      const makesList = this.$store.getters.makesUnlocking;
      
      list = makesList.map(({ id, name, make_id }) => {
        return {
          id,
          name: make_id ? `(${make_id}) ${name}` : name,
        };
      });

      return list.sort(function(a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    years() {

      const isLostCar = this.form[customerModal.LOST_CAR_KEY] !== undefined;
      const isCarUnlocking = this.form[customerModal.CAR_UNLOCKING] !== undefined;

      let year = isLostCar ? 1979 : isCarUnlocking ? 1959 : 1979;

      let list = [];
      while (year < new Date().getFullYear()) {
        year++;
        list.push({
          name: year.toString(),
          value: year.toString(),
        });
      }
      return list.reverse();
    },
    models() {
      let list = [];
      let Make = this.form[customerModal.MAKE_UNLOCKING] || this.form[customerModal.MAKE];
      let Year = this.form[customerModal.YEAR];

      let dynamicMakes =
        this.form[customerModal.LOST_CAR_KEY] !== undefined
          ? this.$store.getters.makes
          : this.form[customerModal.CAR_UNLOCKING] !== undefined
          ? this.$store.getters.makesUnlocking
          : this.$store.getters.makes;

      let item = dynamicMakes.find((item) => {
        return item.id == Make;
      });

      if (item != null) {
        list = item.models.filter((item) => {
          return item.from <= Year && item.to >= Year;
        });
      }
      list = list.map((item) => {
        item.value = item.name;
        return item;
      });
      return list.sort(function(a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    keyCategorieOrAppItemNumbers() {
      let list = [];
      let Make = this.form[customerModal.MAKE];
      let Year = this.form[customerModal.YEAR];
      let Model = this.form[customerModal.MODEL];
      let KeyCategory = this.form[customerModal.KEY_CATEGORY];
      let item = this.$store.getters.makes.find((item) => {
        return item.id == Make;
      });
      if (item != null) {
        list = item.models.filter((item) => {
          return item.from <= Year && item.to >= Year;
        });
        if (this.item.id == customerModal.APPLICABLE_ITEM_NUMBERS) {
          list = item.models.filter((item) => { // getting applicable item number mapped inside the string along with keycategory 
            return item.key_category == KeyCategory.split('key__value')[0] && item.app_item_no == KeyCategory.split('key__value')[1] && item.from <= Year && item.to >= Year;
          });
        }
      }
      let key =
        this.item.id == customerModal.KEY_CATEGORY
          ? "key_category"
          : "app_item_no";

      list = list.filter((i) => i.name == Model && i[key]);
      if(list.length == 1) {
        EventBus.$emit('dialog_data', list[0])
      }
      if (key == "key_category") {

        list = list.map((item) => {
          return {  // modiying value by including app_item_no as well because of allowing duplicate key category list values and majorly for mapping 'key category' with 'Applicable item numebr'
            name: item[key],
            value: `${item["key_category"]}key__value${item["app_item_no"]}`, // key__value is just a unique string will be used for splitting the string
            // value: item[key],
          };
        });
      } else { // as this function is using for both "key category" & "applicable item no." so we dont want to modify value for "applicable items number"
        list = list.map((item) => {
          return {
            name: item[key],
            // value: `${item["key_category"]}~${item["app_item_no"]}`,
            value: item[key],
          };
        });
      }

      return list.sort(function(a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    isZipcode() {
      return this.type === "zipcode";
    },
    isAutocomplete() {
      let types = ["autocomplete", "make", "make-unlocking","model", "year", "zipcode"];
      return types.indexOf(this.type) !== -1;
    },
    isText() {
      let types = ["text", "number", "email"];
      return types.indexOf(this.type) !== -1;
    }, 
    isGreen() {
      if(this.item.id == customerModal.DRIVER_ADDRESS_KEY) {
        return true;
      } else {
        return false
      }
     
    },
    isAddressField() {
      return this.item.id == customerModal.ADDRESSS;
    },
    keyType() {
      let Make = this.form[customerModal.MAKE];
      let Year = this.form[customerModal.YEAR];
      let Model = this.form[customerModal.MODEL];
      let KeyCategory = this.form[customerModal.KEY_CATEGORY];
      let item = this.$store.getters.makes.find((item) => {
        return item.id == Make;
      });
      if (item != null) {
        let list = item.models
          .filter((i) => i.name == Model)
          .filter((item) => {
            return item.from <= Year && item.to >= Year;
          });
        let model = list.find((item) => {
          return (
            item.key_category == KeyCategory.split('key__value')[0] && item.app_item_no == this.model
          );
        });
        let field = this.$store.getters.serviceFields.find(
          (i) => i.id == customerModal.TYPE_OF_KEY
        );

        if (model && model.type_of_key && field) {
          let options = (field.options || []).map((i) => i.name);
          if (options.indexOf(model.type_of_key) != -1) {
            return model.type_of_key;
          }
        }
      }

      return "";
    },

    fullPhoneNumber() {
      if (this.type !== 'phone' || !this.phoneLocalNumber) return this.model;
      
      // Remove all non-digit characters from local number
      const cleanNumber = this.phoneLocalNumber.replace(/\D/g, '');
      if (cleanNumber.length !== 10) return this.model;
      
      // +1 becomes 1, +52 becomes 52
      const countryDigits = this.phoneCountryCode.replace('+', '');
      return `${countryDigits}${cleanNumber}`;
    },

    isValidPhone() {
      if (this.type !== 'phone') {
        return this.model && false; // Your existing logic
      }
      
      // For new phone input: validate 10-digit local number
      const cleanNumber = (this.phoneLocalNumber || '').replace(/\D/g, '');
      return cleanNumber.length !== 10;
    },
  },
  methods: {
    checkNumber() {
      const vm = this;
      if(vm.item.key == customerModal.HOW_PAID){
       
        if(vm?.item?.value.toLowerCase() == 'cash') {
         
          EventBus.$emit('changePaymentToggle','cash');
        } else {
          EventBus.$emit('changePaymentToggle', 'credit_card');
        }
      }
      if (customerModal.PHONE == vm.item.key) {
        if (vm.item && vm.item.value) {
          vm.parsePhoneValue(vm.item.value);
        }
      }
      
      if (vm.item.key == customerModal.BUSINESS_PHONE) {
        if (vm.item && vm.item.value) {
          vm.parsePhoneValue(vm.item.value);
        }
      }
      if (vm.item.key == customerModal.SECONDARY_NUMBER) {
        if (vm.item && vm.item.value) {
          vm.parsePhoneValue(vm.item.value);
        }
      }
    },

    parsePhoneValue(phoneValue) {
      if (!phoneValue || this.type !== 'phone') {
        this.model = phoneValue;
        return;
      }

      const phoneStr = phoneValue.toString().trim();
      const digits = phoneStr.replace(/\D/g, ''); // Get only digits
      
      // Handle backend format (continuous digits)
      if (digits.startsWith('52') && digits.length === 12) {
        // Format: "521234567890" -> country: +52, number: 1234567890
        this.phoneCountryCode = '+52';
        this.phoneLocalNumber = this.formatPhoneDisplay(digits.substring(2));
      } else if (digits.startsWith('1') && digits.length === 11) {
        // Format: "11234567890" -> country: +1, number: 1234567890
        this.phoneCountryCode = '+1';
        this.phoneLocalNumber = this.formatPhoneDisplay(digits.substring(1));
      } else if (digits.startsWith('01') && digits.length >= 12) {
        // Your existing "01" prefix format -> remove "01", assume +1
        this.phoneCountryCode = '+1';
        this.phoneLocalNumber = this.formatPhoneDisplay(digits.substring(2));
      } else if (digits.length === 10) {
        // 10-digit number (assume US)
        this.phoneCountryCode = '+1';
        this.phoneLocalNumber = this.formatPhoneDisplay(digits);
      } else {
        // Default fallback
        this.phoneCountryCode = '+1';
        this.phoneLocalNumber = this.formatPhoneDisplay(digits);
      }
    },
    formatPhoneDisplay(number) {
      if (!number) return '';
      
      const cleanNumber = number.replace(/\D/g, '');
      
      if (cleanNumber.length === 10) {
        return `(${cleanNumber.slice(0,3)}) ${cleanNumber.slice(3,6)}-${cleanNumber.slice(6)}`;
      }
      
      return cleanNumber;
    },

    updatePhoneNumber() {
      if (this.type !== 'phone') return;
      
      // Auto-format the local number as user types
      if (this.phoneLocalNumber) {
        const cleanNumber = this.phoneLocalNumber.replace(/\D/g, '');
        if (cleanNumber.length <= 10) {
          this.phoneLocalNumber = this.formatPhoneDisplay(cleanNumber);
        }
      }

      // ✅ CORRECTED: Update model with continuous digits format for backend
      this.model = this.fullPhoneNumber;
      
      // Emit to parent component
      this.$nextTick(() => {
        this.$emit('input', this.fullPhoneNumber);
        this.$emit('blur');
      });
    },

    async addCMP() {
      const vm = this;
      let form = this.$parent.form;
      let landmark = form[customerModal.LANDMARK];
      let address = form[customerModal.ADDRESSS];
      let map_link = form[customerModal.MAP_LINK];
      let zipcode = form[customerModal.ZIPCODE];
      let doc = {
        updated_at: getDateTime(),
        created_at: getDateTime(),
        zipcode,
        landmark,
        address,
        map_link,
      };
      try {
        vm.$loader.show();
        await cmp.add(doc);
        vm.$loader.hide();
      } catch (error) {
        vm.$alert.show(error.message);
        vm.$loader.hide();
      }
    },
    isObject(data) {
      return typeof data.item !== "object";
    },
    getSelects(items) {
      return items.map((item) => {
        item.value = item.id || item.name;
        return item;
      });
    },
    async getAddressData(addressData, placeResultData) {
      const vm = this;
      if (vm.isAddressField) {
        let { url } = placeResultData;
        try {
          vm.$loader.show();
          // let { data } = await shortenLink(url);
          let shortenUrl = functions.httpsCallable("shortenUrl");
          let { data, message, status } = (await shortenUrl({ url })).data;
          if (status) {
            this.$emit("onAddressLink", data);
          } else {
            vm.$alert.show(message);
          }
          this.$emit("blur");
          vm.$loader.hide();
        } catch (error) {
          vm.$loader.hide();
          vm.$alert.show(error.message);
        }
      }
    },

    input() {
      const vm = this;
      let { key } = vm.item;
      if(key == customerModal.HOW_PAID){
          if(vm.item.value.toLowerCase() == 'cash'){
            EventBus.$emit('changePaymentToggle','cash');
          } else {
            EventBus.$emit('changePaymentToggle', 'credit');
          }
        }
      let weekends = ["sat", "sun"];
      let day = moment
        .tz("America/Los_Angeles")
        .format("ddd")
        .toLowerCase();
      if (key == customerModal.WEEKEND_CHARGES && weekends.indexOf(day) == -1) {
        vm.$alert.show(
          "You are setting Sat-Sun Time Charges on Week days. Are you sure?"
        );
      }

      if (key == customerModal.WEEKDAY_CHARGES && weekends.indexOf(day) != -1) {
        vm.$alert.show(
          "You are setting Mon-Fri Time Charges on Weekend. Are you sure?"
        );
      }

      if (key == customerModal.YEAR || key == customerModal.MAKE_UNLOCKING) {
        this.$emit("updateForm", {
          [`${customerModal.MODEL}`]: "",
          [`${customerModal.LOST_CAR_KEY}`]: 0,
          [`${customerModal.CAR_UNLOCKING}`]: 0,
        });
      }
      if (key == customerModal.MAKE) {
        const Make = this.form[customerModal.MAKE]
        const Model = this.form[customerModal.MODEL]

        let dynamicMakes =
          this.form[customerModal.LOST_CAR_KEY] !== undefined
            ? this.$store.getters.makes
            : this.form[customerModal.CAR_UNLOCKING] !== undefined
              ? this.$store.getters.makesUnlocking
              : this.$store.getters.makes;

        let item = dynamicMakes.find((item) => {
          return item.id == Make;
        });

        const data = item?.models?.find(i => i.name == Model)
        if (data) {
          this.$emit("updateForm", {
            [`${customerModal.LOST_CAR_KEY}`]: 0,
            [`${customerModal.CAR_UNLOCKING}`]: 0,
          });
        }
      }
      if (key == customerModal.MODEL) {
        this.$emit("updateForm", {
          [`${customerModal.KEY_CATEGORY}`]: "",
          [`${customerModal.APPLICABLE_ITEM_NUMBERS}`]: "",
          [`${customerModal.TYPE_OF_KEY}`]: "",
          [`${customerModal.KEY_CHARGE}`]: "",
        });
      }
      if (key == customerModal.KEY_CATEGORY) {
        this.$emit("updateForm", {
          [`${customerModal.APPLICABLE_ITEM_NUMBERS}`]: "",
          [`${customerModal.TYPE_OF_KEY}`]: "",
          [`${customerModal.KEY_CHARGE}`]: "",
        });
      }
      if (key == customerModal.APPLICABLE_ITEM_NUMBERS) {
        this.$emit("updateForm", {
          [`${customerModal.TYPE_OF_KEY}`]: this.keyType,
          [`${customerModal.KEY_CHARGE}`]: "",
        });
      }
      //---------
      if (key == customerModal.TYPE_OF_KEY) {
        let Make = this.form[customerModal.MAKE];
        let Year = this.form[customerModal.YEAR];
        // let dynamicMakes =
        //   this.form[customerModal.LOST_CAR_KEY] !== undefined
        //     ? this.$store.getters.makes
        //     : this.form[customerModal.CAR_UNLOCKING] !== undefined
        //     ? this.$store.getters.makesUnlocking
        //     : [];

        let makeItem = this.$store.getters.makes.find((item) => {
          return item.id == Make;
        });
        if (makeItem != null) {
          let keycategory = this.form[customerModal.KEY_CATEGORY].split('key__value')[0]; // getting key category (looked into keycategoriesorapplicableitems function for look thorugh the initialization of key category value)
          let appItemNo = this.form[customerModal.KEY_CATEGORY].split('key__value')[1];   // getting app_item_no
          const makeModel = makeItem.models.filter((item) => {
            return (
              item.from <= Year &&
              item.to >= Year &&
              item.type_of_key == this.model &&
              item.key_category ==keycategory &&
              item.app_item_no == appItemNo
            );
          });

          let lostCarKeyValue = 0;
          if (
            makeModel.length >= 1 &&
            this.form[`${customerModal.LOST_CAR_KEY}`] !== undefined
          ) {
            lostCarKeyValue = makeModel[0]?.lostCarKey || 0;
          }

          if (this.form[`${customerModal.CAR_UNLOCKING}`]) {
            lostCarKeyValue = 0;
          }

          this.$emit("updateForm", {
            [`${customerModal.LOST_CAR_KEY}`]: lostCarKeyValue,
          });
        }
      }

      if (
        key == customerModal.MODEL &&
        this.form[customerModal.LOST_CAR_KEY] === undefined
      ) {
        let Make = this.form[customerModal.MAKE_UNLOCKING];
        let Year = this.form[customerModal.YEAR];

        let makeItem = this.$store.getters.makesUnlocking.find((item) => {
          return item.id == Make;
        });
        if (makeItem != null) {
          const makeModel = makeItem.models.filter((item) => {
            return (
              item.from <= Year && item.to >= Year && item.name == this.model
            );
          });

          let carUnlockingValue = 0;

          if (
            makeModel.length >= 1 &&
            this.form[`${customerModal.CAR_UNLOCKING}`] !== undefined
          ) {
            carUnlockingValue = makeModel[0]?.carUnlocking || 0;
          }

          this.$emit("updateForm", {
            [`${customerModal.CAR_UNLOCKING}`]: carUnlockingValue,
          });
        }
      }

      if (key == customerModal.OUTSIDE_TECHNICIAN) {
        let technicianValue = this.value;
        let additionalInformation = "";

        if (this.technicianData && this.isTechnicianChanged) {
          technicianValue =
            this.findMatchingString(
              this.options,
              this.technicianData?.first_name
            ) || "NONE";

          const data = this.fieldConditions.filter(
            (d) => d.conditions[0].value == technicianValue
          );
          
          
          // if (data.length) {
          //   additionalInformation = data[0].perform[0].value || "";
          // }
          this.isTechnicianChanged = false;

          if (data.length) {
               this.$emit("updateForm", {
              [`${customerModal.OUTSIDE_TECHNICIAN}`]: technicianValue,
              });
          }else{
            this.$emit("updateForm", {
          [`${customerModal.OUTSIDE_TECHNICIAN}`]: technicianValue,
          [`${customerModal.TECH_ADDITIONAL_INFORMATION}`]: additionalInformation
        });
          }

          this.$emit("updateForm", {
          [`${customerModal.OUTSIDE_TECHNICIAN}`]: technicianValue,
        });
        } 
        else {
          const data = this.fieldConditions.filter(
            (d) => d.conditions[0].value == technicianValue
          );

          if(!data.length){
              this.$emit("updateForm", {
               [`${customerModal.OUTSIDE_TECHNICIAN}`]: technicianValue,
               [`${customerModal.TECH_ADDITIONAL_INFORMATION}`]: additionalInformation
          });
        }
        //   // if (data.length) {
        //   //   const finalData = data[0].perform.filter(
        //   //     (d) => d.field == customerModal.TECH_ADDITIONAL_INFORMATION
        //   //   );
        //     // if (finalData.length) {
        //     //   additionalInformation = finalData[0].value || "";
        //     // }
        //   // }
        }

        // this.$emit("updateForm", {
        //   [`${customerModal.OUTSIDE_TECHNICIAN}`]: technicianValue,
        //   //[`${customerModal.TECH_ADDITIONAL_INFORMATION}`]: additionalInformation
        // });
      }

      //--------------
      this.$nextTick(() => {
        this.$emit("input", vm.model);
        this.$emit("blur");
      });
    },
    async handleTechnicianSelected(data) {
      this.technicianData = data;
      this.isTechnicianChanged = true;
      this.input();
    },
    findMatchingString(arr, inputString) {
      arr = arr.map((e) => e.value);
      let search = inputString.replace(/[^a-zA-Z\s]/g, "").trim().toLowerCase();
      function calculateScore(str1, str2) {
        let words1 = str1.toLowerCase().split(/\s+/);
        let words2 = str2.toLowerCase().split(/\s+/);
        let commonWords = words1.filter((word) => words2.includes(word));
        return commonWords.length;
      }
      let bestMatch = null;
      let highestScore = 0;

      arr.forEach((item) => {
        let score = calculateScore(item, search);
        if (score > highestScore) {
          highestScore = score;
          bestMatch = item;
        }
      });

      return bestMatch;
    },
  },
  mounted() {
    EventBus.$on("technician-selected", this.handleTechnicianSelected);
  },
  beforeMount() {
    this.model = this.value;
  },
};
</script>

<style lang="scss">
.custom__autocomplete {
  .v-input__append-outer {
    margin: 0px !important;
  }
}

.address_input {
  .v-input__append-outer {
    margin: 0px !important;
  }
}
.template-field .v-input__icon--prepend-inner i {
  font-size: 12px !important;
}
.disabled-input input {
  background-color: white !important;
  color: black !important;
  opacity: 1 !important;
  pointer-events: none;
}
.custom-error-look.v-text-field--outlined fieldset {
  border: 1px solid red !important;
}

.green-border .v-input__slot {
  border: 3px solid green !important;
}

/* If you're using outlined style, you might need this instead: */
.green-border fieldset {
  border-color: green !important;
}
</style>
